<template>
  <div class="GptRatingForm">
    <p class="GptRatingForm__content-title">
      <slot name="title">How would you rate this response?</slot>
    </p>
    <ul class="GptRatingForm__rating-options">
      <li
        v-for="option in ratingOptions"
        :key="option.value"
        class="GptRatingForm__rating-option"
      >
        <button
          class="GptRatingForm__rating-option-button"
          @click="$emit('update:modelValue', option.value)"
        >
          <UIIcon
            :key="modelValue >= option.value ? 'starSolid' : 'starRegular'"
            class="GptRatingForm__rating-option-button-icon"
            :name="modelValue >= option.value ? 'starSolid' : 'starRegular'"
          />
        </button>
        <div class="GptRatingForm__rating-option-button-label">
          {{ option.label }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import UIIcon from '../ui/icons/UIIcon.vue'

withDefaults(
  defineProps<{
    modelValue?: number
  }>(),
  {
    modelValue: 0,
  },
)
defineEmits(['update:modelValue'])

const ratingOptions = [
  {
    label: 'Very poor',
    value: 1,
  },
  {
    label: 'Poor',
    value: 2,
  },
  {
    label: 'Average',
    value: 3,
  },
  {
    label: 'Good',
    value: 4,
  },
  {
    label: 'Excellent',
    value: 5,
  },
]
</script>

<style lang="scss" scoped>
.GptRatingForm {
  .GptRatingForm__content-title {
    @include font-size-14px;
    color: $color-neutral-170;
    margin-bottom: 0.25rem;
  }

  .GptRatingForm__rating-options {
    list-style: none;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 0.25rem;
  }

  .GptRatingForm__rating-option-button {
    border: 1px solid $color-neutral-30;
    border-radius: 0.25rem;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;

    &:hover {
      box-shadow: 0px 2px 5px 0px #0000000d;
    }
  }

  .GptRatingForm__rating-option-button-icon {
    --size: 1.5rem;
  }

  .GptRatingForm__rating-option-button-label {
    @include font-size-10px;
    color: $color-neutral-80;
    margin-top: 0.5rem;
    width: 100%;
    text-align: center;
  }
}
</style>
